//Third party libraries
import React, {useEffect, useRef, useState } from 'react';

import styles from './TemplatePreviewPopup.module.css';
import copyIcon from './../../img/copy.png';
import useEmojiReplacement from '../../hooks/useEmojiReplacement';


export const TemplatePreviewPopup = ({ popUpShown, previewText, setShown, optionsPreviewText,showCopyOptions }) => {

  const [copied, setCopied] = useState(false);
  const [optionsCopied, setOptionsCopied] = useState(false);

  // The CRM's legacy Angular editor only understands presentational tags
  // (<b>/<i>/<u>). Our rich-text editor emits semantic tags
  // (<strong>/<em>/<ins>), which the CRM strips on paste, reverting formatting
  // to plain text. Map semantic tags back to legacy tags so the styling
  // survives. Regex tolerates attributes, e.g. <strong style="...">.
  const toLegacyTags = (html) =>
    html
      .replace(/<(strong)(\s[^>]*)?>/gi, '<b$2>')
      .replace(/<\/strong>/gi, '</b>')
      .replace(/<(em)(\s[^>]*)?>/gi, '<i$2>')
      .replace(/<\/em>/gi, '</i>')
      .replace(/<(ins)(\s[^>]*)?>/gi, '<u$2>')
      .replace(/<\/ins>/gi, '</u>')
      .replace(/<(del)(\s[^>]*)?>/gi, '<s$2>')
      .replace(/<\/del>/gi, '</s>');

  // Write both rich HTML (mapped to legacy tags) and a plain-text fallback to
  // the clipboard. Falls back to the legacy selection + execCommand path for
  // browsers without async clipboard / ClipboardItem support.
  const copyNode = (node, markCopied) => {
    if (!node) return;

    const html = toLegacyTags(node.innerHTML);
    const text = node.innerText;

    const done = () => {
      markCopied(true);
      setTimeout(() => markCopied(false), 2000);
    };

    const fallback = () => {
      const range = document.createRange();
      range.selectNode(node);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      done();
    };

    if (
      navigator.clipboard &&
      typeof navigator.clipboard.write === 'function' &&
      typeof ClipboardItem !== 'undefined'
    ) {
      const data = [
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' }),
        }),
      ];
      navigator.clipboard.write(data).then(done).catch(fallback);
    } else {
      fallback();
    }
  };

  const handleCopy = (evt) => {
    evt.preventDefault();
    copyNode(document.querySelector('#message-content-to-copy'), setCopied);
  }

  const handleOptionsCopy = (evt) => {
    evt.preventDefault();
    copyNode(document.getElementById('message-content-options-to-copy'), setOptionsCopied);
  }

  const popupRef = useRef(null);

  //useEmojiReplacement()
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupRef]);

  return (
    (popUpShown) ?
      <div className={styles.popupMain}>
        <div className={styles.popup} ref={popupRef}>
          <button type="button" className={styles.close} aria-label="Close" onClick={() => setShown(!popUpShown)}>
            <span aria-hidden="true">&times;</span>
          </button>
          <div className={styles.content}>
            <div className={styles.title}>Message Preview</div>
            <div className={styles.inputWrapper}>
              <input type="email" placeholder="To" />
              <div className={styles.to}>
                <span>Cc</span>
                <span>Bcc</span>

              </div>
            </div>

            <div className={styles.secondInputWrapper}>
              <input type="text" placeholder="Subject" />
              {showCopyOptions ? <div >
              <button className={styles.btn} onClick={handleOptionsCopy} style={{ marginRight: "20px" }}>
                <img src={copyIcon} alt="Copy icon" className={styles.icon} style={{ marginRight: "5px" }} />
                {optionsCopied ? 'Copied!' : 'Copy Option to clipboard'}
              </button>
              </div> : ''}
              <button className={styles.btn} onClick={handleCopy}>
                <img src={copyIcon} alt="Copy icon" className={styles.icon} style={{ marginRight: "5px" }} />
                {copied ? 'Copied!' : 'Copy to clipboard'}
              </button>
            </div>
            <div className={styles.message} dangerouslySetInnerHTML={{ __html: previewText }} id="message-content-to-copy"></div>
            <div className={styles.messageHidden} dangerouslySetInnerHTML={{ __html: optionsPreviewText }} id="message-content-options-to-copy"></div>
          </div>
        </div>
      </div>
      : ''
  );
}